import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

const linkClass = 'text-[#14A098] underline hover:text-[#0e7a74] transition-colors';

/**
 * Form footer: Terms & Privacy Policy with routes to policy pages.
 */
export default function FormLegalNotice({ className = 'text-xs text-gray-500 mt-2 w-full' }) {
  const { t } = useLanguage();

  return (
    <p className={className}>
      {t('contact.legal_intro', 'By submitting, you agree to our')}{' '}
      <Link to="/terms" className={linkClass}>
        {t('contact.terms', 'Terms')}
      </Link>
      {' '}
      {t('contact.legal_and', '&')}
      {' '}
      <Link to="/privacy" className={linkClass}>
        {t('contact.privacy_policy', 'Privacy Policy')}
      </Link>
      {t('contact.legal_suffix', '.')}
    </p>
  );
}
